"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const uuid_1 = require("uuid");
// MUI
const mui_1 = require("tss-react/mui");
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const CompareArrowsRounded_1 = __importDefault(require("@mui/icons-material/CompareArrowsRounded"));
const QButton_1 = __importDefault(require("components/QButton"));
const renameRulesSelectors_1 = require("companion-app-components/flux/rename-rules/renameRulesSelectors");
const renameRulesTypes_1 = require("companion-app-components/flux/rename-rules/renameRulesTypes");
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const RulesRow_1 = __importDefault(require("./RulesRow"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const headCells = [
    { id: 'renameTo', label: 'Rename to' },
    { id: 'matchingRule', label: 'Matching rule' },
    { id: 'downloadedName', label: 'Downloaded name' },
];
const RulesTable = (props) => {
    const getRenameRules = (0, react_redux_1.useSelector)((state) => (0, renameRulesSelectors_1.getRulesById)(state), react_redux_1.shallowEqual);
    const { classes } = useStyles(props);
    const [rules, setRules] = React.useState(getRenameRules);
    const [newRule, setNewRule] = React.useState({});
    const [disableAll, setDisableAll] = React.useState(false);
    React.useEffect(() => {
        if (!(0, immutable_1.is)(rules, getRenameRules)) {
            setRules(getRenameRules);
        }
    }, [getRenameRules, rules]);
    const handleAdd = () => {
        const clientId = (0, uuid_1.v4)().toUpperCase();
        setNewRule((0, renameRulesTypes_1.mkRenameRule)({ id: 0, clientId }));
        setDisableAll(true);
    };
    const removeNewTempRule = () => {
        setNewRule({});
    };
    return (<>
      <Grid_1.default container direction="row" justifyContent="space-between" alignItems="center" className={classes.header}>
        <Typography_1.default variant="h5" className={classes.headlineText}>
          <CompareArrowsRounded_1.default className={classes.headlineIcon}/>
          Renaming Rules
        </Typography_1.default>
        <QButton_1.default id="add-new-rule" variant="contained" onClick={handleAdd} disabled={disableAll}>
          <Add_1.default className={classes.iconSpacing}/> Add
        </QButton_1.default>
      </Grid_1.default>

      {rules.size <= 0 && !newRule.clientId ?
            <ZeroStateView_1.default style={{ margin: 40 }} primary="No Data" secondary="Click the add button to add new rule" size="small"/>
            :
                <Table_1.default component="div" size="small" className={classes.rulesTable}>
          <TableHead_1.default component="div">
            <TableRow_1.default component="div">
              {headCells.map((headCell) => (<TableCell_1.default component="div" key={headCell.id}>
                  <Typography_1.default variant="body2" className={classes.thFont}>{headCell.label}</Typography_1.default>
                </TableCell_1.default>))}
              <TableCell_1.default align="right" component="div"/>
            </TableRow_1.default>
          </TableHead_1.default>

          <TableBody_1.default component="div">
            {newRule.clientId &&
                        <RulesRow_1.default key={newRule.clientId} row={newRule} setDisableAll={setDisableAll} disableAll={disableAll} editable removeNewTempRule={removeNewTempRule} rules={rules}/>}
            {rules.size > 0 && rules.valueSeq().map((row) => <RulesRow_1.default key={row.id || row.clientId} row={row} setDisableAll={setDisableAll} disableAll={disableAll} editable={false} rules={rules}/>)}
          </TableBody_1.default>
        </Table_1.default>}
    </>);
};
exports.default = RulesTable;
